import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useGetSalesHistoryQuery } from 'services/api/sales';
import { selectTabFilters } from 'services/salesHistorySlice/salesHistorySlice';
import { useDeviceInfo } from 'hooks/useDeviceInfo';
import VehicleGridCard from './VehicleGridCard';
import MobileTransactionCard from './MobileTransactionCard';

const AllPage = ({ page }: { page: number }) => {
  const { perPage } = useSelector((state: any) => state.salesHistory);
  const filters = useSelector((state: any) => selectTabFilters(state, 'all'));
  const { data } = useGetSalesHistoryQuery({ limit: perPage, offset: page, ...filters });
  const { isMobile } = useDeviceInfo();

  const vehicles = useMemo(() => data?.rows?.ids?.map((id: any) => data?.rows?.entities?.[id]) ?? [], [data]);

  const CardComponent = isMobile ? MobileTransactionCard : VehicleGridCard;

  return (
    <>
      {vehicles.map((vehicle: any) => (
        <CardComponent key={vehicle.id} vehicle={vehicle} />
      ))}
    </>
  );
};

export default AllPage;
